var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import Icon from "@irati/ui/src/Icon";
import { FormattedMessage, FormattedCurrency } from "@irati/utils/lang";
import authentication from "@irati/auth";
import { StyledBalanceCard, IconWrapper } from "./styled";
var RewardWalletUsersBalance = /** @class */ (function (_super) {
    __extends(RewardWalletUsersBalance, _super);
    function RewardWalletUsersBalance() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RewardWalletUsersBalance.prototype.render = function () {
        var rewardWallet = this.props.rewardWallet;
        var currency = authentication.defaultUserCurrency();
        return (React.createElement(StyledBalanceCard, null,
            React.createElement(IconWrapper, null,
                React.createElement(FormattedMessage, { id: "wallet.tenant.refund.rewardWallet" }),
                React.createElement(Icon, { icon: "wallet" })),
            React.createElement(FormattedCurrency, { isCents: false, currency: currency, value: rewardWallet.availableBalance })));
    };
    RewardWalletUsersBalance.defaultProps = {
        hideLabel: false
    };
    return RewardWalletUsersBalance;
}(PureComponent));
export default RewardWalletUsersBalance;
